import ShowCauseNotice from "@pages/ShowCauseNotice";
import ShowCauseNoticeEdit from "@pages/ShowCauseNotice/Detail/ShowCauseNotice";
import ShowCauseNoticeDetail from "@pages/ShowCauseNotice/Detail/TaskDetails";
import ShowCauseNoticeHistory from "@pages/ShowCauseNotice/Detail/TaskHistory";

export const ShowCauseNoticeRoutes = [
  {
    path: "/report/show-cause-notice",
    name: "report_show_cause_notice",
    component: ShowCauseNotice,
  },
  {
    path: "/report/show-cause-notice/details/:id",
    name: "report_show_cause_notice",
    component: ShowCauseNoticeDetail,
  },
  {
    path: "/report/show-cause-notice/history/:id",
    name: "report_show_cause_notice",
    component: ShowCauseNoticeHistory,
  },
  {
    path: "/report/show-cause-notice/add",
    name: "report_show_cause_notice",
    component: ShowCauseNoticeEdit,
  },
  {
    path: "/report/show-cause-notice/edit/:id",
    name: "report_show_cause_notice",
    component: ShowCauseNoticeEdit,
  },
];
